<template>
  <div class="page">
    <div class="clearfix header" style>
      <span class="rt-pos" @click="goBack()"></span>
      <div
        class="arrow pull-left"
        :class="{active: activeIndex == 0 || activeIndex == 1}"
        @click="changeTab()"
      >
        <span class="num">1</span>
        <span>实名手机验证</span>
      </div>
      <div
        class="arrow pull-right disable"
        :class="{active: activeIndex == 1}"
        @click="changeTab()"
      >
        <span class="num">2</span>
        <span>上传实名信息</span>
      </div>
    </div>
    <div v-if="activeIndex == 0">
      <div class="search-box">
        <img class="simcard" src="../assets/img/simcard.png" />
        <input class="search-input" maxlength="20" placeholder="请输入ICCID号" v-model="iccid" :disabled="true"/>
      </div>

      <div class="search-box">
        <img class="simcard" src="../assets/img/user.png" />
        <input class="search-input" maxlength="11" placeholder="请输入手机号码" v-model="mobile" type="tel"/>
      </div>
      <div class="search-box">
        <img class="simcard" src="../assets/img/codes.png" />
        <input class="search-input" maxlength="4" placeholder="请输入验证码" v-model="code" type="tel"/>
        <div class="input-code">
          <span v-show="show" @click="getCode" class="opt-a">获取验证码</span>
          <span v-show="!show" class="count opt-a">{{count}}s后可重发</span>
        </div>
      </div>

      <nut-button block class="elbutton" @click="next">下一步</nut-button>

    </div>
    <div v-if="activeIndex == 1">
      <div class="search-box">
        <input
          class="search-input"
          maxlength="10"
          placeholder="请输入真实姓名"
          style="text-indent:10px;"
          v-model="realName"
        />
      </div>
      <div class="search-box">
        <input
          class="search-input"
          maxlength="18"
          placeholder="请输入身份证号"
          style="text-indent:10px;"
          v-model="idCard"
          type="tel"
        />
      </div>
      <div id="pup1" class="search-box2 mgt30">
        <div class="pup-bg" v-show="aa">
          <nut-uploader
            id="upfront" class="bta"
            name="img"
            :url="url"
            :isPreview="true"
            :acceptType = "['image/jpeg','image/png']"
            @success="onSuccess"
            @fail="onFail"
            typeError="对不起，不支持上传该类型文件！"
            limitError="对不起，文件大小超过限制！"
          >
          上传身份证正面
          </nut-uploader> 
        </div>
        <img class="reg-img" :src="home1" />
      </div>
      <div id="pup2" class="search-box2 mgt30">
        <div class="pup-bg" v-show="bb">
          <nut-uploader
            id="upfront" class="bta"
            name="img"
            :url="url"
            :isPreview="true"
            :acceptType = "['image/jpeg','image/png']"
            @success="onSuccess2"
            @fail="onFail"
            typeError="对不起，不支持上传该类型文件！"
            limitError="对不起，文件大小超过限制！"
          >
          上传身份证反面
          </nut-uploader> 
        </div>
        <img class="reg-img" :src="home2" />
      </div>
      <div id="pup2" class="search-box2 mgt30">
        <div class="pup-bg" v-show="cc">
          <nut-uploader
            id="upfront" class="bta"
            name="img"
            :url="url"
            :isPreview="true"
            :acceptType = "['image/jpeg','image/png']"
            @success="onSuccess3"
            @fail="onFail"
            typeError="对不起，不支持上传该类型文件！"
            limitError="对不起，文件大小超过限制！"
          >
          上传手持身份证半身照
          </nut-uploader> 
        </div>
        <img class="reg-img" :src="home3"/>
      </div>
      <nut-button block class="certification" @click="certification" >提交认证</nut-button>
    </div>
    <div id="pup-error" v-show="ashow">
      <p id="error-info">{{message}}</p>
    </div>
  </div>
</template>

<script>

import { wx_sendCertSms } from "@/api/api.js"; //发送短信
import { wx_verifyCertCode } from "@/api/api.js"; //验证码校验
import { wx_saveCertRecord } from "@/api/api.js"; //提交信息
import home1 from "../assets/img/p1.png";
import home2 from "../assets/img/p2.png";
import home3 from "../assets/img/p3.png";

export default {
  name: "auth",
  data() {
    return {
      // 遮罩的显示
      aa:true,
      bb:true,
      cc:true,
      // 图片的链接
      home1: home1,
      home2: home2,
      home3: home3,
      // 弹窗消息的显示
      ashow: false,
      message:'',
      // 切换
      activeIndex: 0,
      timeSecond: 60,
      // 倒计时的显示
      show: true,
      count: "",
      timer: null,
      // 传参数
      iccid: "",
      mobile: "",
      idCard: "",
      realName: "",
      row:'',
      row2:'',
      row3:'',
      code: "",

      url:'/cms/upload/uploadImage',
      gaibianurl:'/cms/upload/image/',
    };
  },
  computed: {},
  methods: {
    // 后退到上一页
    goBack(){
      this.$router.go(-1);
    },
    changeTab(i){
    },
    onSuccess(file,res){
      var row =JSON.parse(res).data;
      this.row = row;
      var url = this.gaibianurl + row;
      this.home1 = url;
      this.aa = false;
      this.$toast.success('上传成功');
    },
    onSuccess2(file,res){
      var row =JSON.parse(res).data;
      this.row2 = row;
      var url = this.gaibianurl + row;
      this.home2 = url;
      this.bb = false;
      this.$toast.success('上传成功');
    },    
    onSuccess3(file,res){
      var row =JSON.parse(res).data;
      this.row3 = row;
      var url = this.gaibianurl + row;
      this.home3 = url;
      this.cc = false,
      this.$toast.success('上传成功');
    },
    onFail(file,res){
      console.log("res",res)
      alert('上传失败！');
    },
    // 倒计时
    getCode() {
      let params = {
        iccid: this.iccid,
        phone: this.mobile
      };
      wx_sendCertSms(params).then(res => {
        if (res.data.code == 200) {
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        }else{
          this.message = res.data.message;
          this.ashow = true;
          setTimeout(() => {
            this.ashow = false;
          }, 2000);

        }
      });
    },
    // 验证短信验证码
    next() {
      let params = {
        iccid: this.iccid,
        phone: this.mobile,
        code: this.code,
      };
      wx_verifyCertCode(params).then(res => {
        if (res.data.code == 200) {
          this.activeIndex = 1;
        }else{
          this.message = res.data.message;
          this.ashow = true;
          setTimeout(() => {
            this.ashow = false;
          }, 2000);
        }
      })
    },
    // 提交实名信息
    certification() {
      if(this.idCard.length < 15)return this.$toast.warn('身份证位数不能少于15位');
      let params = {
        iccid: this.iccid,
        phone: this.mobile, 
        idCard: this.idCard,
        realName:this.realName,
        headImg:this.row,
        backImg:this.row2,
        peopleImg :this.row3
      };
      wx_saveCertRecord(params).then(res => {
        if (res.data.code == 200) {
          this.message = res.data.data;
          this.ashow = true;
          setTimeout(() => {
            this.ashow = false;
          }, 2000);
          setTimeout(() => {
            this.$router.push({
              name: "info",
              query: {
                iccid: this.iccid
              }
            })
          }, 2000);
        }else{
          this.message = res.data.message;
          this.ashow = true;
          setTimeout(() => {
            this.ashow = false;
          }, 2000);
        }
      })
    },
  },
  created() {
    this.iccid = this.$route.query.iccid
  },
  mounted() {}
};
</script>

<style scoped>
.header {
  width: 100%;
  display: flex;
  position: relative;
}
.rt-pos{
  position: absolute;
  left: 20px;
  top:14px;
  width: 12px;
  height: 12px;
  border-top: 2px solid gainsboro;
  border-left: 2px solid gainsboro;
  transform: rotate(-45deg);
  z-index: 2;
}
.arrow {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  width: 50%;
  position: relative;
  font-size: 12px;
  text-align: center;
  background-color: #979797;
  color: #fff;
}
.arrow.active {
  background: #F94040;
}
.search-box {
  position: relative;
  margin: 8% auto 15px;
  text-align: center;
  border: none;
}
.search-box .simcard {
  width: 30px;
  height: 30px;
  margin-left: 2px;
  position: absolute;
  top: 3px;
}
.search-box .search-input {
  width: 80%;
  height: 40px;
  line-height: 40px;
  border: 1.2px solid #999;
  border-radius: 5px;
  text-indent: 35px;
  outline: none;
  font-size: 14px;
  -webkit-appearance:none;
}
.input-code {
  position: absolute;
  right: 50px;
  top: 14%;
  height: 30px;
}
.input-code .opt-a {
  display: block;
  width: 75px;
  height: 30px;
  line-height: 30px;
  background: #3eaef9;
  color: #fff;
  font-size: 12px;
  text-align: center;
}
.elbutton {
  width: 80% !important;
  height: 40px;
  line-height: 40px;
  margin: 0 auto;
  text-align: center;
  display: block;
  border-right: 10px !important;
  background: #F94040;
}
.certification {
  width: 80% !important;
  height: 40px;
  line-height: 40px;
  margin: 0 auto;
  text-align: center;
  display: block;
  border-right: 10px !important;
  background: #F94040;
  margin-top: 20px;
}
.search-box2 {
  position: relative;
  text-align: center;
  margin: 0 auto;
  width: 80%;
  margin-top: 15px;
}
.search-box2 .pup-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
}
.search-box2 .pup-bg .bta {
  display: block;
  font-size: 18px;
  line-height: 115px;
  color: #fff;
  height: 100%;
}
.search-box2 .reg-img {
  width: 175px;
  height: 120px;
  line-height: 120px;
  margin: auto;
  vertical-align: bottom;
}
#pup-error {
  position: fixed;
  z-index: 500;
  width: 100%;
  bottom: 95px;
  text-align: center;
  transform: scale(0.5);
  opacity: 1;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
}
#error-info {
  opacity: 1;
  color: #fff;
  border-radius: 6px;
  background-color: #000;
  font-size: 32px;
  display: inline-block;
  word-wrap: break-word;
  word-break: break-all;
  width: 100%;
  height: 75px;
  line-height: 75px;
}
</style>
